import axios from 'axios';
import { getAuth } from 'firebase/auth'; // Firebase Auth import


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class LookUpService {

    
    async getUsagePurposes() {

        return axios.get(`${API_BASE_URL}/public/usage-purposes`, {
        });
    }


 }

export default new LookUpService();
